<template>
  <div class="secondary">
    <v-container fluid class=" pt-0 ">
      <!--<v-card class="pa-2 mb-3 shadow-1 card-r">-->
        <!--<v-toolbar class="primary card-r pl-3 text-white">-->
          <!--<div class="text-xs-left f-20">Exams</div>-->
        <!--</v-toolbar>-->
      <!--</v-card>-->
      <v-card class="pa-2 mb-3 shadow-1 card-r">

        <v-layout row wrap class="">
          <v-flex>
            <v-tabs dark hide-slider class="top-tab w-100"
                    slot="extension" v-model="profileTabs"
                    centered fixed-tabs color="transparent">
              <v-tabs-slider color="white"></v-tabs-slider>
              <v-tab to="#createquestions" class="primary--text f-12 w-16 "> Create Question</v-tab>
              <v-tab to="#draft" class="primary--text f-12 w-16">Drafts</v-tab>
              <v-tab to="#allquestions" class="primary--text f-12 w-16">All Questions</v-tab>
              <!--<v-tab to="#createtest" class="primary&#45;&#45;text f-12 w-16">CreateTest</v-tab>-->
              <v-tab to="#tests" class="primary--text f-12 w-16">Practice Exams</v-tab>
              <v-tab to="#packages" class="primary--text f-12 w-16">Exam Packages</v-tab>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-card>
      <div class="h-50 scroll-y">

      <v-layout>
        <v-flex>
          <v-tabs-items v-model="profileTabs">
            <v-tab-item id="createquestions" >
              <create-questions/>
            </v-tab-item>
            <v-tab-item id="allquestions">
              <all-questions/>
            </v-tab-item>
            <v-tab-item id="draft">
              <draft/>
            </v-tab-item>
            <!--<v-tab-item id="createtest">-->
            <!--<create-test/>-->
            <!--</v-tab-item>-->
            <v-tab-item id="tests">
              <tests/>
            </v-tab-item>
            <v-tab-item id="packages">
              <packages/>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </div>
    </v-container>
  </div>
</template>
<script>
  /* eslint-disable */
  import CreateQuestions from "./CreateQuestions";
  import AllQuestions from "./AllQuestions";
  import Draft from "./Draft";
  import CreateTest from "./CreateTest";
  import Tests from "./Tests";
  import Packages from "./Packages";

  export default {
    name: "ExamsTab",
      data: () => ({
      profileTabs: "packages"
    }),
    components: {
      CreateQuestions,
      AllQuestions,
      Draft,
      CreateTest,
      Tests,
      Packages
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/pages/exams/ExamsTab.vue